export default {
  namespaced: true,
  state: {
    $tag: {},
    $module: {},
    $refreshMap: {},
    $localRefreshMap: {},
    $action: {
      setQuery: (module) => `queryTable/${module}/SET_QUERY`,
      setPager: (module) => `queryTable/${module}/SET_PAGER`,
      updatePager: (module) => `queryTable/${module}/UPDATE_PAGER`
    }
  },
  mutations: {
    registerModule (state, { module, tag }) {
      const tags = state.$tag[tag]
      if (tags && tags.indexOf(module) === -1) {
        tags.push([module])
      } else if (!tags) {
        state.$tag[tag] = [module]
      }
      state.$module[module] = tag
    },
    unregisterModule (state, tags) {
      tags.forEach(v => {
        let modules = state.$tag[v]
        if (modules) {
          state.$tag[v] = []
          modules.forEach(m => {
            state.$module[m] = ''
            delete state[m]
          })
        }
      })
    },
    refresh (state, payload) {
      const tag = payload.tag
      // 替换本地数据，并重新渲染 canvas
      if (payload.module && payload.cb) {
        state.$localRefreshMap[tag] = payload
      }
      // 记录需要刷新的 queryTable
      if (!state.$refreshMap[tag]) {
        state.$refreshMap = { ...state.$refreshMap, [tag]: payload.module || true }
      }
    },
    unrefresh (state, tag) {
      delete state.$localRefreshMap[tag]
      delete state.$refreshMap[tag]
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/store/modules/queryTable/index.js